<template>
    <div class="content has-text-grey has-text-centered">
      <p>
        <b-icon icon="emoticon-sad" size="is-large" />
      </p>
      <p>Nenhum registro encontrado</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'EmptyState'
  };
  </script>